

























































































































import { Component, Prop } from "vue-property-decorator";
import { CompanyStatusModel, FileDownloadModel } from "@/core/models";
import { CompanyService, QuestionnaireService } from "@/core/services";
import UpdateFollowupStatusDialogCpt from "./UpdateFollowupStatusDialogCpt.vue";
import CompleteRevisionDialogCpt from "./CompleteRevisionDialogCpt.vue";
import { RevStatusCpt, FollowUpStatusCpt } from "./status-badges";
import { GridTableCpt } from "@/core/components";

import AppVue from "@/AppVue.vue";

@Component({
  components: {
    UpdateFollowupStatusDialogCpt,
    CompleteRevisionDialogCpt,
    RevStatusCpt,
    FollowUpStatusCpt,
    GridTableCpt,
  },
})
export default class WorkshopClientRevGridCpt extends AppVue {
  @Prop() companyId: number;

  model = {} as CompanyStatusModel;
  loading = false;
  showFollowupStatusDialog = false;
  showCompleteDialog = false;
  currentQuestionnaireId = 0;

  columns = [
    { label: "Rev.", prop: "revNumber", slot: "revNumber", width: "90px", sortable: true },
    { label: "Status", prop: "isOpen", slot: "status", width: "120px", sortable: true },
    { label: "Last Updated On", prop: "dateCompleted", slot: "dateCompleted", width: "170px", sortable: true },
    { label: "Last Updated By", prop: "completedByName", slot: "completedByName", width: "220px", sortable: true },
    { label: "Notes", prop: "comments", slot: "comments", width: "250px", sortable: true },
    { label: "Actions", prop: "actions", slot: "actions", width: "250px", sortable: false },
  ];

  async created() {
    this.initializeModel();
  }

  private async downloadCriticalSkillsReport(id: number) {
    this.loading = true;
    try {
      const response: FileDownloadModel = await QuestionnaireService.downloadCriticalSkillsReport(id);
      await QuestionnaireService.generateCriticalSkillsFile(response);
    } finally {
      this.loading = false;
    }
  }
  private close(saved: boolean) {
    this.showFollowupStatusDialog = false;
    this.showCompleteDialog = false;
    if (saved === true) {
      this.initializeModel();
    }
  }

  private complete(questionnaireId: number) {
    this.currentQuestionnaireId = questionnaireId;
    this.showCompleteDialog = true;
  }

  private updateFollowUpStatus() {
    this.showFollowupStatusDialog = true;
  }

  private async initializeModel() {
    this.loading = true;
    try {
      this.model = await CompanyService.getStatusById(this.companyId);
    } finally {
      this.loading = false;
    }
  }
}
